import { ChatTextIcon } from "@eworkit/iris";
import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { IEmailPreferences } from "@/data/email-preferences";

import { EmailNotificationSetting } from "./EmailNotificationSetting";
import { EmailNotificationSettingsGroup } from "./EmailNotificationSettingsGroup";

interface IChatSettingsProps {
  emailPreferences: IEmailPreferences;
  onChange?: <T extends IEmailPreferences, K extends keyof T>(key: K, value: T[K]) => void;
}

export const ChatSettings: FC<IChatSettingsProps> = memo(({ emailPreferences, onChange }) => {
  const { t } = useTranslation("session");

  return (
    <EmailNotificationSettingsGroup
      header={t("USERS.SETTINGS.EMAIL_NOTIFICATIONS.CHAT.HEADER")}
      frequencyTooltipText={t("USERS.SETTINGS.EMAIL_NOTIFICATIONS.CHAT_FREQUENCY_TOOLTIP")}>
      <EmailNotificationSetting
        icon={ChatTextIcon}
        name={t("USERS.SETTINGS.EMAIL_NOTIFICATIONS.CHAT.NEW_MESSAGES")}
        isChecked={emailPreferences.chatNewMessagesEnabled}
        onChange={value => onChange?.("chatNewMessagesEnabled", !!value)}
      />
    </EmailNotificationSettingsGroup>
  );
});
